module.exports = __webpack_public_path__ + "img/app_logo.002bbbe6.png";